// Internal modules
import { appStore } from '@/store';

const getUserAgreementPath = (): string => {
  const { api: apiState } = appStore.getState();
  const noticeAndConsentUrl = apiState?.userAgreement?.activeUrl;

  return noticeAndConsentUrl || 'ua/useragreement-full';
};

export { getUserAgreementPath };
